import { useLang } from '@/i18n';
import EfImg from 'elem/ui/ef-img';
import EfLink from 'elem/ui/ef-link';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import css from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('dp3.landing.EU11');
    const { locale } = useRouter();
    const hrefA = `https://homebattery.ecoflow.com/${locale}/products/PowerOcean`;
    return (
        <div className={`${css['thecomp']} GtmModuleData-section`} data-section-id={'dp3-EU11'} data-section-title={t('title')}>
            <EfSpec className="spec-x" />
            <div className="box">
                <div className="info">
                    <p className="title">{t('title')}</p>
                    <EfLink
                        className="link"
                        href={hrefA}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'jump_button',
                            position: 'Inpage',
                            button_name: t('link'),
                            url: hrefA,
                        }}
                    >
                        {t('link')}
                        <span>&nbsp;&gt;</span>
                    </EfLink>
                </div>
                <div className="img">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1723807604371/image%201297%20%E6%8B%B7%E8%B4%9D%201.png"
                        h5="https://websiteoss.ecoflow.com/upload/image/1723807566324/sl_dpu%20bundle.png"
                    />
                </div>
            </div>
        </div>
    );
}
